export const GOOGLE_API_KEY = process.env.VITE_GOOGLE_API_KEY as string;
